import React from 'react'

import Card from 'react-bootstrap/Card';


const Cardd = ({ className, onClick, header, footer, title, content }) => {
  return (
    <Card className={className} onClick={onClick}>
      <Card.Header>{header}</Card.Header>
      <Card.Body>
        <Card.Title> {title} </Card.Title>
        <Card.Text>
          {content}
        </Card.Text>
      </Card.Body>
      <Card.Footer>{footer}</Card.Footer>
    </Card>
  )
}

export default Cardd;
